import styles from "./icon.module.scss";
import type { IconViewProps } from "./types-icon";

export function IconView({
  viewBox,
  size,
  name,
  figma,
  testId,
  rest,
  role,
  ariaLabelledBy,
  ariaHidden,
  className,
  style,
  title,
  titleId,
  paths,
  secondaryPaths,
}: IconViewProps) {
  return (
    <svg
      viewBox={viewBox}
      fill="currentColor"
      fillRule="evenodd"
      xmlns="http://www.w3.org/2000/svg"
      focusable="false"
      data-size={size}
      data-icon={name}
      data-figma={figma}
      data-testid={testId}
      {...rest}
      role={role}
      aria-labelledby={ariaLabelledBy}
      aria-hidden={ariaHidden}
      className={[styles.root, className].filter(Boolean).join(" ")}
      style={style}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      {paths.map((d) => (
        <path key={d} d={d} />
      ))}
      {(secondaryPaths ?? []).map((d) => (
        <path key={d} d={d} className={styles.secondary} />
      ))}
    </svg>
  );
}
